export default __webpack_public_path__ + "374e3589b1aef6a890ba71fc2c27070a.glb";